import { use } from "react";

import { CompanyContext } from "@domain/context/CompanyContext";
import type { GQL } from "@binale-tech/shared";
import { ProductAccessUtils } from "@domain/models/utils/ProductAccessUtils";
import { type ProductKey } from "@domain/models/Product";
import { UserContext } from "@domain/context/UserProvider";

export const useCanWrite = (productKey: ProductKey) => {
    const user = use(UserContext);
    const { companyGQL } = use(CompanyContext);
    const canWrite = ProductAccessUtils.canWrite(productKey, companyGQL, user);
    return canWrite;
};
export const useCanWriteDocuments = () => {
    const user = use(UserContext);
    const { companyGQL } = use(CompanyContext);
    return ProductAccessUtils.canWriteDocuments(companyGQL, user);
};
export const useCanRead = (productKey: GQL.IProductKey) => {
    const user = use(UserContext);
    const { companyGQL } = use(CompanyContext);
    return ProductAccessUtils.canRead(productKey, companyGQL, user);
};
